module.exports = __webpack_public_path__ + "96f852767efd7b055b34dcbc54799525.svg";